module.exports = __webpack_public_path__ + "img/maze_star_c.ead98fc6.svg";